import { Badge } from '@vds/badges';
import { ButtonIcon } from '@vds/button-icons';
import { Icon } from '@vds/icons';
import { TileContainer } from '@vds/tiles';
import { Body, Micro, Title } from '@vds/typography';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import './LearningPath.scss';
import ResourceTag from '../common/ResourceTag/resourceTag';
import { isMobile, isDesktop } from 'react-device-detect';
import { getImageToBeRendered, getWithExpiry } from '../../utility/utils';
import { useSelector } from 'react-redux';

const LearningPathCard = (props) => {
  const { data ,sectionKey} =  props
  const history = useNavigate()
  const { t, i18n } = useTranslation();
  const userLanguage = localStorage.getItem("lng")
   const imgFormat = useSelector((state) => state?.Aem?.imgFormat) ?? 'avif';

  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkIsTablet = () => {
      const width = window.innerWidth;
      setIsTablet(width >= 768 && width <= 1023);
    };

    // Check on component mount
    checkIsTablet();

    // Add event listener for window resize
    window.addEventListener('resize', checkIsTablet);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIsTablet);
    };
  }, []);

  const screenType = isDesktop ? "desktop" : isTablet ? "tablet" : isMobile ? "mobile" : "desktop";
  const resourseId =  data?.courseId?.split(":")?.[1];
  // const defaultImageUrl = getImageToBeRendered("learningpath", screenType, "learningpath", userLanguage, resourseId)
  const [imageUrl, setImageUrl] = useState('');


  // seo logic
useEffect(() => {
  // Helper to test if a URL is valid and reachable within 2 seconds
    const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      if (!url || url.trim() === "") return reject(new Error("Invalid URL"));
      const img = new Image();
      img.src = url;
      const timeout = setTimeout(() => {
        img.src = ""; // Stop the browser from continuing to load
        reject(new Error("Timeout"));
      }, 2000);
      
      img.onload = () => {
        clearTimeout(timeout);
        resolve(url);
      };
      img.onerror = () => {
        clearTimeout(timeout);
        reject(new Error("Image Load failed"));
      };
    });
  };

   const loadImage = async () => {
    
    setImageUrl('');

    try {
      // 1.Call method with "avif" parameter
      try {
       const avifUrl = await getImageToBeRendered("learningpath", screenType, "learningpath", userLanguage, resourseId, data?.desktopImage, imgFormat,sectionKey);
        await preloadImage(avifUrl); 
        setImageUrl(avifUrl);
        return; 
      } catch (e) {
        console.warn("AVIF failed, trying PNG...");
      }

      // 2. Call method without "avif" (defaults to PNG)
      // try {
      //   const pngUrl = getImageToBeRendered(renditionType, screenType, modifiedType, userLanguage, resourseId, data?.desktopImage);
      //   await preloadImage(pngUrl);
      //   setImageUrl(pngUrl);
      //   return; 
      // } catch (e) {
      //   console.warn("PNG failed, trying Fallback Data...");
      // }

      // 3. LMS image as fallback
      
      const dataFallbackUrl = data?.lmsImage || data?.desktopImage;
      if (dataFallbackUrl) {
        try {
          await preloadImage(dataFallbackUrl);
          setImageUrl(dataFallbackUrl);
          return;
        } catch (e) {
          console.warn("fallback image failed to load.");
        }
      }

      // setting ulr as empty string
      setImageUrl('');    

    } catch (error) {
     
      setImageUrl('');
    } finally {
      
    }
  };

  loadImage();
}, [screenType,imgFormat]);




  //
  
  // useEffect(() => {
  //   const img = new Image();
  //   img.src = getImageToBeRendered("learningpath", screenType, "learningpath", userLanguage, resourseId)
  //   img.onerror = () => {
  //     setImageUrl(data?.lmsImage ?? "");
  //   };
  // }, [props]);
  
  // Device detection for tablet (768px - 1023px)

  useEffect(() => {
    const checkIsTablet = () => {
      const width = window.innerWidth;
      setIsTablet(width >= 768 && width <= 1023);
    };

    // Check on component mount
    checkIsTablet();

    // Add event listener for window resize
    window.addEventListener('resize', checkIsTablet);

    // Cleanup
    return () => {
      window.removeEventListener('resize', checkIsTablet);
    };
  }, []);

  const handleClick = () => {  
    window.scrollTo(0, 0);
    const courseDetails = JSON.stringify({ label: props.data.label, courseId: props.data.courseId })
    localStorage.setItem("learningPathObj", courseDetails);
    history(`/learning-details/${props.data.courseId}`)
  }
  const getTimeInLanguage = (time) => {
    time = time?.replace('minutes remaining', t('minutes remaining'));
    time = time?.replace('minutes', t('minutes'));
    return time;
  };

  return (
    <TileContainer
      ariaLabel={props.data?.ariaLabel?.replace("undefined", "") + props?.data?.label}
      // padding='40px'
      padding={isTablet ? '24px' : '40px'}
      // aspectRatio='1127:318'
      // aspectRatio={isTablet ? '665:388' : '1127:318'}
      height={isTablet ? '388px' : 'auto'}
      backgroundColor="white"
      showBorder={false}
      showDropShadow={true}
      tabIndex={-1}
      onClick={(e) => handleClick()}
    >
      <div className="learningPathCard">
        <div className='image-icons'>
          {props?.data?.tag &&
            <ResourceTag text={t(props?.data?.tag)}/>
          }
          {props?.data?.showBookmarkIcon &&
            <span className='ml-auto' role='button'>
              <ButtonIcon
                kind="lowContrast"
                size="small"
                surfaceType="media"
                renderIcon={(props) => <Icon name="bookmark" {...props} />}
              />
            </span>
          }
        </div>
        <div className="image">
          <img src={imageUrl} alt={props?.data?.label} />
        </div>
        
        <div className="description sm-pa-4X">
        {props.data.shortDesc && (
          <div className='shortDescription sm-mb-2X'>
            <Body size='small' bold>
              <span className='bg-monarch pa-2X ph-3X ideas' >
                <Icon name='ideas-solutions' size="small"></Icon>
                {props.data.shortDesc?.slice(0, 72)}
              </span>
            </Body>

          </div>
        )}
          
          <div className='label mb-3X sm-mb-2X'>
            <Micro>
              <div className='course-label' aria-label={props?.data?.resourceType}>
                <b>{t(props?.data?.format)}</b>
                {props?.data?.resourceType &&
                  <span className='dot-wrap mh-2X'></span>}
                <span className=''>{props?.data?.resourceType?.split(',').map(e=> t(e.trim())).join(', ')}</span>
              </div>
            </Micro>
          </div>
          <div className="title-label label mb-3X sm-mb-2X" aria-label={props?.data?.label}>
            <Title bold={false} color='#000000' size='XLarge'> {props?.data?.label?.slice(0, 72)}</Title>
          </div>
          <div className="durations mt-auto">

            <div className="duration-text" aria-label={props?.data?.dateAndTimeValue} >
              {props?.data?.duration?.preTextIcon && <Icon
                name={props?.data?.duration?.preTextIcon ? props?.data?.duration?.preTextIcon : "calendar"}
                size="small"
                color={props?.data?.duration?.color}
              />}
              {props.data?.duration?.preText && (<Micro
                size="small"
                color={props?.data?.duration?.color}
                bold={true}
                primitive="span">
                <span className='mr-1X'> {t(props?.data?.duration?.preText)}</span>
              </Micro>)}
              {(props?.data?.duration?.icon || props?.data?.dateAndTimeValue) && (props?.data?.duration?.icon != "" || props?.data?.dateAndTimeValue !== '') && <Icon
                name={props?.data?.duration?.icon ? props?.data?.duration?.icon : "count-down"}
                size="small"
                color={props?.data?.duration?.color}
              />}
              {props.data?.dateAndTimeValue && (<Micro
                size="small"
                color={props?.data?.duration?.color}
                bold={true}
                primitive="span">
                <span className='mr-1X'> {t(getTimeInLanguage(props?.data?.dateAndTimeValue))}</span>
              </Micro>)}
              <Micro
                size="small"
                color={props?.data?.duration?.color}
                bold={true}
                primitive="span">
                <span className="ml-1X">{t(getTimeInLanguage(props?.data?.duration?.time))}</span>
              </Micro>
              {props.data?.duration?.extLink && (
                <TextLink
                  type='inline'
                  size='small'
                  onClick={e => window.open(props?.data?.duration?.extLink?.link, '_blank').focus()}>
                  <span className="ml-1X" style={{ color: props?.data?.duration?.color }}>{t(props?.data?.duration?.extLink?.text)}</span>
                </TextLink>)}
              {props.data?.inProgress && (
                <TextLink
                  type='inline'
                  size='small'
                  onClick={e => { callJoinNow(props.data); }}>
                  <span className="ml-1X" style={{ color: props?.data?.duration?.color }}>{t(props?.data?.linkText)}</span>
                </TextLink>)}
            </div>

            <div>
              <ButtonIcon
                //tabIndex={0}
                kind="ghost"
                size="medium"
                ariaLabel={`${props?.data?.ariaLabel ? props?.data?.ariaLabel?.replace('undefined', '') : ""} ${props?.data?.label} ${t(props?.data?.format)}`}
                role='link'
                renderIcon={(props) => <Icon name="right-arrow" {...props} />}
                onClick={e=>handleClick()}
              />
            </div>
          </div>

        </div>

      </div>

    </TileContainer>
  );
};

export default LearningPathCard;